import { RoleRoute, RoleRouteObject } from '@/types'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import { defer, LoaderFunction } from 'react-router-typesafe'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { isUserRoleAllowed } from '@/routes/utils'
import { faReceipt } from '@fortawesome/free-solid-svg-icons'
import ExpenseCreatorRoute from '@/routes/expenses/ExpenseCreator.route'
import ExpenseEditorRoute from '@/routes/expenses/ExpenseEditor.route'
import ExpensesPage from '@/routes/expenses/ExpensesPage'
import { Azienda } from '@/enums'

export const expensesPageRouteLoader = (async () => {
  const qsAdminApi = useQsAdminApiManager.getState().service
  const userInfo = await getAzureUserInformation()

  const getImpiegati = qsAdminApi.user().query((builder, impiegato) => {
    builder.select('id', 'fullname', 'email', 'manager')
    builder.expanding('manager', (managerBuilder, manager) => {
      managerBuilder.select('id', 'fullname', 'email')
    })
    builder.filter(impiegato.azienda.props.id.eq(Azienda.QS).and(impiegato.contractor.eq(false)))
    if (!isUserRoleAllowed(userInfo?.roles, [Roles.GlobalAdministrator, Roles.Administrator, Roles.Supervisor]))
      builder.filter(
        impiegato.email.eq(userInfo?.email ?? '').or(impiegato.manager?.props.email.eq(userInfo?.email ?? '')),
      )
    builder.orderBy(impiegato.fullname.asc())
  })

  return defer({
    title: 'Spese',
    impiegati: await getImpiegati,
    userInfo,
    defaultCRUDAllowedRoles: [
      Roles.GlobalAdministrator,
      Roles.Administrator,
      Roles.Supervisor,
      Roles.Sales,
      Roles.Marketing,
      Roles.TechDeveloper,
    ],
  })
}) satisfies LoaderFunction

export const ExpensesPageRoute: RoleRoute = {
  path: 'expenses',
  children: [
    {
      index: true,
      element: <ExpensesPage />,
      loader: expensesPageRouteLoader,
      allowedRoles: [
        Roles.GlobalAdministrator,
        Roles.Administrator,
        Roles.Marketing,
        Roles.TechDeveloper,
        Roles.Sales,
        Roles.Supervisor,
      ],
    } as RoleRouteObject,
    ExpenseCreatorRoute,
    ExpenseEditorRoute,
  ],
  errorElement: <RouterErrorHandler />,
  text: 'Spese',
  faIcon: faReceipt,
  handle: {
    crumb: () => ({
      label: 'Spese',
      icon: faReceipt,
    }),
  },
  allowedRoles: [
    Roles.GlobalAdministrator,
    Roles.Administrator,
    Roles.Marketing,
    Roles.TechDeveloper,
    Roles.Sales,
    Roles.Supervisor,
  ],
}
